/**
 * Divisor de sección con textura de papel perforado ("línea de corte"), en
 * vez de un simple border-t — refuerza la metáfora "la página es papel" que
 * ya está en el resto del sitio, en el lugar exacto donde antes solo había
 * una regla plana entre secciones.
 */
export default function PerforatedDivider({ className = '' }) {
    return <div className={`perforated-divider ${className}`} aria-hidden="true" />;
}
